// @flow

import { connect } from 'react-redux';
import { fetchContentful } from 'client/actions/contentful';
import TaxGuidePage from './taxGuidePage';

const mapStateToProps: Object = state => ({
  contentfulData: state.contentfulData,
});

export default connect(mapStateToProps, { fetchContentful })(TaxGuidePage);
